import React from "react";
import { View, StyleSheet } from "react-native";
import { Books } from "@phosphor-icons/react/dist/csr/Books";
import { Users } from "@phosphor-icons/react/dist/csr/Users";

import CustomText from "../../common/general/CustomText/CustomText";

interface AdminDashboardMetricsProps {
  metrics: {
    totalStudents: number;
    activeCourses: number;
  };
}

const AdminDashboardMetrics: React.FC<AdminDashboardMetricsProps> = ({ metrics }) => {
  return (
    <View style={styles.container}>
      <View style={styles.metricsGrid}>
        {/* Total Students */}
        <View style={styles.metricCard}>
          <View style={styles.metricHeader}>
            <CustomText text="Total Students" size="s" weight="medium" style={styles.metricTitle} />
            <View style={[styles.metricIcon, styles.studentsIcon]}>
              <Users size={20} color="#FFFFFF" />
            </View>
          </View>
          <CustomText
            text={metrics.totalStudents.toString()}
            size="m"
            textType="display"
            weight="ultraBold"
            style={styles.metricValue}
            useTranslationText={false}
          />
        </View>

        {/* Active Courses */}
        <View style={styles.metricCard}>
          <View style={styles.metricHeader}>
            <CustomText text="Active Courses" size="s" weight="medium" style={styles.metricTitle} />
            <View style={[styles.metricIcon, styles.coursesIcon]}>
              <Books size={20} color="#FFFFFF" />
            </View>
          </View>
          <CustomText
            text={metrics.activeCourses.toString()}
            size="m"
            textType="display"
            weight="ultraBold"
            style={styles.metricValue}
            useTranslationText={false}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 32,
  },
  metricsGrid: {
    flexDirection: "row",
    gap: 24,
  },
  metricCard: {
    flex: 1,
    backgroundColor: "#FCFCFD",
    borderRadius: 16,
    padding: 24,
    borderWidth: 1,
    borderColor: "#EAECF0",
  },
  metricHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  metricTitle: {
    color: "#6B7280",
    flex: 1,
    marginRight: 12,
    textTransform: "uppercase",
  },
  metricIcon: {
    width: 48,
    height: 48,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  studentsIcon: {
    backgroundColor: "#913DAF",
  },
  coursesIcon: {
    backgroundColor: "#1A8E9D",
  },
  metricValue: {
    color: "#111827",
    marginBottom: 4,
  },
});

export default AdminDashboardMetrics;
